import { render, staticRenderFns } from "./MyContactUs.vue?vue&type=template&id=0def728c&scoped=true"
import script from "./MyContactUs.vue?vue&type=script&lang=js"
export * from "./MyContactUs.vue?vue&type=script&lang=js"
import style0 from "./MyContactUs.vue?vue&type=style&index=0&id=0def728c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0def728c",
  null
  
)

export default component.exports